const WEBHOOK_CATEGORIES = {
  claim: 'Claims',
  payments: 'Payments',
  exposure: 'Exposures',
  recoveries: 'Recoveries',
} as const;

export default WEBHOOK_CATEGORIES;
